import { Component, Input, OnInit } from '@angular/core';
import { Practitioner } from '../../../core/model/v2/practitioner/practitioner';
import { ReviewDetail } from "../../../core/model/v2/review/review-detail";
import { ReviewSummary } from "src/app/core/model/v2/review/review-summary";
import { ReviewService } from "../../../core/services/v2/review-service";
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-rating-reviews',
  templateUrl: './rating-reviews.component.html',
  styleUrls: ['./rating-reviews.component.scss']
})
export class RatingReviewsComponent implements OnInit {
  @Input() SymptomData: Practitioner = new Practitioner();
  reviewSummary: ReviewSummary;
  reviewDetail: ReviewDetail;
  npiNumber: string;
  indexer: number;
  readmoreText: string = 'Read More';
  width1: number;
  width2: number;
  width3: number;
  width4: number;
  width5: number;
  constructor(private reviewService: ReviewService, private loaderService: WindowLoaderService,) { }

  ngOnInit() {
  }
  ngOnChanges() {
    
    this.SymptomData;
    if (this.SymptomData) {
      this.npiNumber = this.SymptomData.npi;
      this.getReviewDetail(this.npiNumber);
      this.getReviewSummary(this.npiNumber);
    }
  }
  getReviewDetail(npi: string) {
    
    this.loaderService.show();
    this.reviewService.getReviewDetail(npi).subscribe(
      (details) => {
        this.reviewDetail = details;
        this.width1 = (this.reviewDetail.oneStar * 100) / (this.reviewDetail.reviews.length);
        this.width1 = Math.trunc(this.width1);
        this.width2 = (this.reviewDetail.twoStars * 100) / (this.reviewDetail.reviews.length);
        this.width2 = Math.trunc(this.width2);
        this.width3 = (this.reviewDetail.threeStars * 100) / (this.reviewDetail.reviews.length);
        this.width3 = Math.trunc(this.width3);
        this.width4 = (this.reviewDetail.fourStars * 100) / (this.reviewDetail.reviews.length);
        this.width4 = Math.trunc(this.width4);
        this.width5 = (this.reviewDetail.fiveStars * 100) / (this.reviewDetail.reviews.length);
        this.width5 = Math.trunc(this.width5);
        console.log("GetReviewDetail Result: ", this.reviewDetail);
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); });
  }

  getReviewSummary(npi: string) {
    
    this.loaderService.show();
    this.reviewService.getReviewSummary(npi).subscribe(
      (details) => {

        this.reviewSummary = details;
        console.log("GetReviewSummary Result: ", this.reviewSummary);
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); });
  }

  toggleReadMore(i) {
    this.indexer = i;
    if (this.readmoreText == 'Read More') {
      this.readmoreText = 'Read Less';
    }
    else {
      this.readmoreText = 'Read More';
  }

}
}
